export default __webpack_public_path__ + "static/media/Mindly-Show.9d8fe478.png";